import React from 'react';
export function UrgencyBanner() {
  return <section className="bg-gradient-to-r from-navy-800 to-teal-600/40 py-[64px] px-6" data-id="element-439">
      <div className="max-w-[640px] mx-auto text-center" data-id="element-440">
        <h2 className="font-serif text-white text-[36px] font-bold mb-5 leading-tight" data-id="element-441">
          These Bonuses Are Included Today Only
        </h2>

        <p className="font-sans text-white/80 text-[16px] leading-[1.8] mb-10" data-id="element-442">
          The 3 bonuses above are available at no extra cost with your order
          today. They are not sold separately. They are not available anywhere
          else. When you get The 11PM Spine Reset today, you get all 3 —
          immediately, free, and yours to keep.
        </p>

        <a href="#final-cta" className="inline-flex items-center justify-center w-full max-w-[520px] h-[64px] bg-teal-400 text-navy-800 font-bold text-[17px] uppercase rounded-[12px] shadow-[0_8px_32px_rgba(45,212,191,0.3)] hover:scale-[1.02] hover:shadow-[0_12px_40px_rgba(45,212,191,0.4)] transition-all" data-id="element-443">
          YES — GIVE ME THE BONUSES FOR FREE →
        </a>

        <p className="font-sans text-gold text-[13px] italic mt-4" data-id="element-444">
          Instant digital access. All 3 bonuses delivered immediately.
        </p>
      </div>
    </section>;
}